import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { IconContainer } from '@/atoms/IconContainer/IconContainer';
import ArrowDown from '@/icons/dropdown.svg?react';

export const MenuButton = React.forwardRef<HTMLButtonElement, ButtonType>(
  ({ children, arrow = false, disabled = false, ...props }, forwardedRef) => {
    return (
      <StyledTrigger asChild {...props} disabled={disabled} ref={forwardedRef}>
        <button>
          {children}
          {arrow ? (
            <IconContainer className='w-5 h-5'>
              <ArrowDown />
            </IconContainer>
          ) : null}
        </button>
      </StyledTrigger>
    );
  }
);

type ButtonType = DropdownMenuPrimitive.DropdownMenuTriggerProps & {
  arrow?: boolean;
};

const StyledTrigger = styled(DropdownMenuPrimitive.Trigger)`
  ${tw`flex flex-row items-center justify-between text-gray-700`}

  &[data-disabled] {
    ${tw`text-gray-400 cursor-not-allowed`}

    & svg {
      ${tw`text-gray-400`}
    }
  }

  & svg {
    ${tw`fill-current`}
  }
`;
